import {
    IS_LOADING,
    IS_LOADINGINTRO,
    IS_LOADINGFRIST
} from '../actionTypes';


export const isLoading = (type) => ({
    type: IS_LOADING,
    payload: type
});

export const isLoadingIntro = (type) => ({
    type: IS_LOADINGINTRO,
    payload: type
});
export const isLoadingFrist = (type) => ({
    type: IS_LOADINGFRIST,
    payload: type
});

